export default __webpack_public_path__ + "static/media/size.dd17eb86.svg";